import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const ratioBargainConfigEntity: Entity = {
  model: model,
  repository: repository,
}

export default ratioBargainConfigEntity
